function getDataAttrs(props: Record<string, any>): Record<string, string> {
  return Object.keys(props)
    .filter((prop) => prop.startsWith("data-"))
    .reduce(
      (acc, prop) => ({
        ...acc,
        [prop]: props[prop] as string,
      }),
      {} as Record<string, string>,
    );
}

export default getDataAttrs;
